<template>
    <div class="mt-4 row justify-content-center">
        <div class="row mb-5">
            <div class="col-12 col-lg-10 mt-3 my-lg-0 px-0 mx-auto">
                <div class="row g-0 justify-content-evenly justify-content-sm-center align-items-center">
                    <div class="col-auto">
                        <a 
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': true,
                            }">Calendario</a>
                    </div>
                    <div class="col-auto">
                        <a 
                            :href="'/structure/student/session/ListAction?userId=' + userId"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': false,
                            }">Elenco</a>
                    </div>
                </div>
            </div>
        </div>

        <div ref="calendar" class="col-sm-12 col-md-6 pt-10">
        </div>
        
        <MbSessionForm ref="adddSessionModal" 
            :userId="parseInt(userId)"
            @reload="onReload()"></MbSessionForm>
    </div>
</template>
<script>

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import itLocale from '@fullcalendar/core/locales/it';
import MbSessionForm from './MbSessionForm.vue';

export default {
    components: {
        MbSessionForm
    },
    props: {
        userId: Number
    },
    data() {
        return {
            calendar: null,
            display: 'calendar'
        }
    },
    destroy(){
        if (this.calendar) {
            this.calendar.destroy();
        }
    },
    mounted() {
        let _this = this

        this.calendar = new Calendar(this.$refs.calendar, {
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrap5Plugin],
            editable: true,
            locale: itLocale,
            initialView: 'dayGridMonth',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
            },
            eventSources: [
                {
                    url: '/structure/student/session/CalendarAction-events?outFormat=json&userId=' + this.userId,
                    method: 'GET',
                    failure: function() {
                        alert('there was an error while fetching events!');
                    }
                }
            ],
            dateClick(evt){
                _this.$refs.adddSessionModal.setDate(evt.date) 
                _this.$refs.adddSessionModal.toggle()
            },
        });

        this.$nextTick(() => {
            this.calendar.render();
        });
    },
    methods: {
        onReload(){
            this.calendar.refetchEvents()
        }
    }
}

</script>
<style>
@media (max-width: 576px){
    .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr{
        display: block !important;
    }
    .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr div{
        margin-bottom: 15px;
        text-align: center;
    }
}
</style>